(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["wildcardRegex"] = factory();
	else
		root["wildcardRegex"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.l = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };

/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};

/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};

/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
function stringToPattern(inputString) {
  var length = inputString.length;
  var character;
  var pattern = '^';
  for (var index = 0; index < length; index++) {
    character = inputString.charAt(index);
    if (character === '*') {
      pattern = pattern + '.*'
    } else {
      pattern = pattern + character;
    }
  }
  pattern = pattern + '$';
  return pattern;
};

function arrayToPattern(inputArray) {
  var length = inputArray.length;
  var wildcardString;
  var nextSubPattern;
  var pattern = '';
  for (var index = 0; index < length; index++) {
    wildcardString = inputArray[index];
    nextSubPattern = stringToPattern(wildcardString);
    if (index === 0) {
      pattern = pattern + nextSubPattern;
    } else {
      pattern = pattern + '|' + nextSubPattern;
    }
  }
  return pattern;
};

function wildcardPattern(stringOrArray) {
  var pattern;
  if (stringOrArray.constructor === String) {
    pattern = stringToPattern(stringOrArray);
  } else if (stringOrArray.constructor === Array) {
    pattern = arrayToPattern(stringOrArray);
  } else {
    throw TypeError('WildcardRegex only accepts a string or array as an argument');
  }
  return pattern;
  var regex = new RegExp(pattern);
  return regex;
};

/* harmony default export */ exports["a"] = wildcardPattern;


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wildcardPattern__ = __webpack_require__(0);


function wildcardRegExp(stringOrArray) {
  var pattern = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wildcardPattern__["a" /* default */])(stringOrArray);
  var regExp = new RegExp(pattern);
  return regExp;
};

/* harmony default export */ exports["a"] = wildcardRegExp;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wildcardPattern__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wildcardRegExp__ = __webpack_require__(1);



/* harmony reexport (binding) */ __webpack_require__.d(exports, "wildcardPattern", function() { return __WEBPACK_IMPORTED_MODULE_0__wildcardPattern__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "wildcardRegExp", function() { return __WEBPACK_IMPORTED_MODULE_1__wildcardRegExp__["a"]; });



/***/ }
/******/ ]);
});